import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ICidadeUFCount {
  cidade: string;
  uf: string;
  total: number;
}

export interface ICidadeUFCountResponse {
  cidadesUfs: Array<{
    cidade: string;
    uf: string;
    quantidade?: number;
  }>;
  cidadesValidas?: string[];
  cidadesInvalidas?: string[];
}

interface ICidadeUFState {
  cidadeUFCount: ICidadeUFCountResponse;
  loading: boolean;
  error: string | null;
}

const initialState: ICidadeUFState = {
  cidadeUFCount: {
    cidadesUfs: [],
  },
  loading: false,
  error: null,
};

const CidadeUFSlice = createSlice({
  name: "cidadeUF",
  initialState,
  reducers: {
    setCidadeUFCountState(state, action) {
      state.cidadeUFCount = action.payload.cidadeUFCount;
      state.loading = false;
      state.error = null;
    },

    // NOVAS ACTIONS
    setCidadesValidasState(state, action: PayloadAction<string[]>) {
      state.cidadeUFCount.cidadesValidas = action.payload
    },
    setCidadesInvalidasState(state, action: PayloadAction<string[]>) {
      state.cidadeUFCount.cidadesInvalidas = action.payload
    },
    setCidadeUFLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setCidadeUFError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    clearCidadeUFState(state) {
      state.cidadeUFCount = {
        cidadesUfs: [],
      };
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setCidadeUFCountState,
  setCidadeUFLoading,
  setCidadeUFError,
  clearCidadeUFState,
  setCidadesValidasState,
  setCidadesInvalidasState,
} = CidadeUFSlice.actions;

export const CidadeUFReducer = CidadeUFSlice.reducer;
